import { fork, all, } from 'redux-saga/effects';
import { watchCallGetPayment } from './all_payment.saga';
import { watchCallGetPaymentDetail } from './single_payment.saga';
import { watchCallDownloadCsv } from './download_transaction_csv.saga';

function* transactionsSaga() {
    yield all([fork(watchCallGetPayment), fork(watchCallGetPaymentDetail), fork(watchCallDownloadCsv)]);
}

export default transactionsSaga;
